<script>
  import Aicon from "./Aicon.svelte";

  import prettyB from "pretty-bytes";
  import { session, routerboard } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  let routerboards;
  $: routerboards;
  routerboard.subscribe((value) => {
    routerboards = value;
  });

  export let PathNote = false;
  export let Fixed = false;
  let cssMenu;
  if (Fixed !== false) {
    cssMenu =
      "fixed bottom-0 left-0 right-0 z-10 p-0 mx-0 bg-gray-100 border-t rounded-none " +
      "shadow lg:p-2 md:p-0 lg:rounded-lg md:rounded-none lg:relative md:fixed lg:bg-" +
      "white md:bg-gray-100 lg:block lg:shadow-lg lg:z-auto md:z-10 lg:border-none md" +
      ":border-t";
  } else {
    cssMenu =
      "relative px-2 mx-0 bg-gray-100 rounded-lg shadow lg:bg-white md:bg-gray-100 lg:" +
      "block lg:shadow-lg";
  }
  let routerID;
  $: if (sessions.routeractive) {
    routerID = sessions.routeractive.id;
  } else {
    routerID = 1;
  }
</script>

<div class="w-full gap-2 -mt-10 lg:flex">
  <div class="w-full mt-0 lg:mt-5 md:mt-2 lg:w-2/5">
    <div
      class="relative mx-0 -mt-16 bg-white rounded-lg shadow-lg lg:block lg:-mt-20 md:-mt-16 "
    >
      <div
        class="flex flex-no-wrap pb-4 mx-auto my-0 items-justify lg:flex-wrap"
      >
        <Aicon
          lg="w-2/6"
          md="w-2/6"
          xs="w-2/6"
          css="border"
          notif={sessions.notifications.invoice}
          text="Invoice"
          href="/invoice"
        >
          <svg
            class="inline-block w-12 h-12 text-gray-800 stroke-current"
            xmlns="http://www.w3.org/2000/svg"
            version="1"
            viewbox="0 0 48 48"
            enable-background="new 0 0 48 48"
          >
            <path
              fill="#78909C"
              d="M40,41H8c-2.2,0-4-1.8-4-4l0-20.9c0-1.3,0.6-2.5,1.7-3.3L24,0l18.3,12.8c1.1,0.7,1.7,2,1.7,3.3V37 C44,39.2,42.2,41,40,41z"
            />
            <rect x="14" y="1" fill="#AED581" width="20" height="31" />
            <g fill="#558B2F">
              <path d="M13,0v33h22V0H13z M33,31H15V2h18V31z" />
              <path
                d="M34,3c0,1.7-0.3,3-2,3c-1.7,0-3-1.3-3-3s1.3-2,3-2C33.7,1,34,1.3,34,3z"
              />
              <path
                d="M16,1c1.7,0,3,0.3,3,2s-1.3,3-3,3s-2-1.3-2-3S14.3,1,16,1z"
              />
              <circle cx="24" cy="8" r="2" />
              <circle cx="24" cy="20" r="6" />
            </g>
            <path
              fill="#CFD8DC"
              d="M40,41H8c-2.2,0-4-1.8-4-4l0-20l20,13l20-13v20C44,39.2,42.2,41,40,41z"
            />
          </svg>
        </Aicon>
        <Aicon
          lg="w-2/6"
          md="w-2/6"
          xs="w-2/6"
          css="shadow-xl bg-gray-100 -mt-4"
          text="Server"
          href="/server"
        >
          <svg
            class="inline-block w-12 h-12 text-gray-800 stroke-current"
            xmlns="http://www.w3.org/2000/svg"
            version="1"
            viewbox="0 0 48 48"
            enable-background="new 0 0 48 48"
          >
            <path
              fill="#E38939"
              d="M12,40V8c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"
            />
            <path
              fill="#FFF3E0"
              d="M32,7H16c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8C33,7.4,32.6,7,32,7z"
            />
            <circle fill="#A6642A" cx="24" cy="41" r="1.5" />
            <circle fill="#E91E63" cx="24" cy="23" r="2" />
            <circle
              fill="none"
              stroke="#F48FB1"
              stroke-width="2"
              stroke-miterlimit="10"
              cx="24"
              cy="23"
              r="4"
            />
            <circle
              fill="none"
              stroke="#F8BBD0"
              stroke-miterlimit="10"
              cx="24"
              cy="23"
              r="6.5"
            />
          </svg>
        </Aicon>
        <Aicon
          lg="w-2/6"
          md="w-2/6"
          xs="w-2/6"
          css="border"
          text="Points"
          href="/points"
        >
          <svg
            class="inline-block w-12 h-12 text-gray-800 stroke-current"
            xmlns="http://www.w3.org/2000/svg"
            version="1"
            viewbox="0 0 48 48"
            enable-background="new 0 0 48 48"
          >
            <g fill="#FFA000">
              <path
                d="M38,13c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,12.1,41.3,13,38,13 z"
              />
              <path
                d="M38,10c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,9.1,41.3,10,38,10z"
              />
              <path
                d="M38,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,15.1,41.3,16,38,16 z"
              />
              <path
                d="M38,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,18.1,41.3,19,38,19 z"
              />
              <path
                d="M38,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,21.1,41.3,22,38,22 z"
              />
              <path
                d="M38,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,24.1,41.3,25,38,25 z"
              />
              <path
                d="M38,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,27.1,41.3,28,38,28 z"
              />
              <path
                d="M38,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,30.1,41.3,31,38,31 z"
              />
              <path
                d="M38,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,33.1,41.3,34,38,34 z"
              />
              <path
                d="M38,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,36.1,41.3,37,38,37 z"
              />
              <path
                d="M38,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,39.1,41.3,40,38,40 z"
              />
            </g>
            <g fill="#FFC107">
              <ellipse cx="38" cy="8" rx="6" ry="2" />
              <path
                d="M38,12c-2.8,0-5.1-0.6-5.8-1.5C32.1,10.7,32,10.8,32,11c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,11.4,40.8,12,38,12z"
              />
              <path
                d="M38,15c-2.8,0-5.1-0.6-5.8-1.5C32.1,13.7,32,13.8,32,14c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,14.4,40.8,15,38,15z"
              />
              <path
                d="M38,18c-2.8,0-5.1-0.6-5.8-1.5C32.1,16.7,32,16.8,32,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,17.4,40.8,18,38,18z"
              />
              <path
                d="M38,21c-2.8,0-5.1-0.6-5.8-1.5C32.1,19.7,32,19.8,32,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,20.4,40.8,21,38,21z"
              />
              <path
                d="M38,24c-2.8,0-5.1-0.6-5.8-1.5C32.1,22.7,32,22.8,32,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,23.4,40.8,24,38,24z"
              />
              <path
                d="M38,27c-2.8,0-5.1-0.6-5.8-1.5C32.1,25.7,32,25.8,32,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,26.4,40.8,27,38,27z"
              />
              <path
                d="M38,30c-2.8,0-5.1-0.6-5.8-1.5C32.1,28.7,32,28.8,32,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,29.4,40.8,30,38,30z"
              />
              <path
                d="M38,33c-2.8,0-5.1-0.6-5.8-1.5C32.1,31.7,32,31.8,32,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,32.4,40.8,33,38,33z"
              />
              <path
                d="M38,36c-2.8,0-5.1-0.6-5.8-1.5C32.1,34.7,32,34.8,32,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,35.4,40.8,36,38,36z"
              />
              <path
                d="M38,39c-2.8,0-5.1-0.6-5.8-1.5C32.1,37.7,32,37.8,32,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,38.4,40.8,39,38,39z"
              />
            </g>
            <g fill="#FFA000">
              <path
                d="M10,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,18.1,13.3,19,10,19 z"
              />
              <path
                d="M10,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,15.1,13.3,16,10,16 z"
              />
              <path
                d="M10,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,21.1,13.3,22,10,22 z"
              />
              <path
                d="M10,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,24.1,13.3,25,10,25 z"
              />
              <path
                d="M10,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,27.1,13.3,28,10,28 z"
              />
              <path
                d="M10,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,30.1,13.3,31,10,31 z"
              />
              <path
                d="M10,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,33.1,13.3,34,10,34 z"
              />
              <path
                d="M10,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,36.1,13.3,37,10,37 z"
              />
              <path
                d="M10,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,39.1,13.3,40,10,40 z"
              />
            </g>
            <g fill="#FFC107">
              <ellipse cx="10" cy="14" rx="6" ry="2" />
              <path
                d="M10,18c-2.8,0-5.1-0.6-5.8-1.5C4.1,16.7,4,16.8,4,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,17.4,12.8,18,10,18z"
              />
              <path
                d="M10,21c-2.8,0-5.1-0.6-5.8-1.5C4.1,19.7,4,19.8,4,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,20.4,12.8,21,10,21z"
              />
              <path
                d="M10,24c-2.8,0-5.1-0.6-5.8-1.5C4.1,22.7,4,22.8,4,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,23.4,12.8,24,10,24z"
              />
              <path
                d="M10,27c-2.8,0-5.1-0.6-5.8-1.5C4.1,25.7,4,25.8,4,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,26.4,12.8,27,10,27z"
              />
              <path
                d="M10,30c-2.8,0-5.1-0.6-5.8-1.5C4.1,28.7,4,28.8,4,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,29.4,12.8,30,10,30z"
              />
              <path
                d="M10,33c-2.8,0-5.1-0.6-5.8-1.5C4.1,31.7,4,31.8,4,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,32.4,12.8,33,10,33z"
              />
              <path
                d="M10,36c-2.8,0-5.1-0.6-5.8-1.5C4.1,34.7,4,34.8,4,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,35.4,12.8,36,10,36z"
              />
              <path
                d="M10,39c-2.8,0-5.1-0.6-5.8-1.5C4.1,37.7,4,37.8,4,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,38.4,12.8,39,10,39z"
              />
            </g>
            <g fill="#FFA000">
              <path
                d="M24,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,27.1,27.3,28,24,28 z"
              />
              <path
                d="M24,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,24.1,27.3,25,24,25 z"
              />
              <path
                d="M24,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,30.1,27.3,31,24,31 z"
              />
              <path
                d="M24,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,33.1,27.3,34,24,34 z"
              />
              <path
                d="M24,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,36.1,27.3,37,24,37 z"
              />
              <path
                d="M24,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,39.1,27.3,40,24,40 z"
              />
            </g>
            <g fill="#FFC107">
              <ellipse cx="24" cy="23" rx="6" ry="2" />
              <path
                d="M24,27c-2.8,0-5.1-0.6-5.8-1.5C18.1,25.7,18,25.8,18,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,26.4,26.8,27,24,27z"
              />
              <path
                d="M24,30c-2.8,0-5.1-0.6-5.8-1.5C18.1,28.7,18,28.8,18,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,29.4,26.8,30,24,30z"
              />
              <path
                d="M24,33c-2.8,0-5.1-0.6-5.8-1.5C18.1,31.7,18,31.8,18,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,32.4,26.8,33,24,33z"
              />
              <path
                d="M24,36c-2.8,0-5.1-0.6-5.8-1.5C18.1,34.7,18,34.8,18,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,35.4,26.8,36,24,36z"
              />
              <path
                d="M24,39c-2.8,0-5.1-0.6-5.8-1.5C18.1,37.7,18,37.8,18,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,38.4,26.8,39,24,39z"
              />
            </g>
          </svg>
        </Aicon>
      </div>
      <div
        class="p-2 text-center border-t border-gray-200 rounded-lg cursor-pointer hover:bg-gray-100 hover:shadow-lg"
      >
        {#if sessions.routeractive}
          {#if sessions.routeractive.logo}
            <img
              src="{sessions.api}/logo/{sessions.routeractive.logo}"
              alt={sessions.routeractive.name}
              class="h-12 mx-auto"
            />
          {/if}
          <span class="px-3 text-xs text-gray-700 bg-gray-300 rounded-lg"
            ><b>{sessions.routeractive.name}</b> is active</span
          >
          {#if PathNote !== false}
            <p class="pt-3 my-2 text-xs border-t">{PathNote}</p>
          {/if}
        {:else}
          <span class="w-4 h-4"
            ><span
              class="absolute inline-flex w-4 h-4 bg-gray-400 rounded-full opacity-75 animate-ping"
            />
            <span
              class="relative inline-flex w-4 h-4 overflow-hidden rounded-full"
              ><img src="./assets/svg/gps.svg" width="27px" alt="gps" /></span
            ></span
          ><br />
          <b>PILIH SERVER</b><br />
          <span class="px-3 text-xs text-red-700 bg-red-300 rounded-lg"
            >Tidak Terhubung</span
          >
          {#if PathNote !== false}
            <p class="pt-3 my-2 text-xs border-t">{PathNote}</p>
          {/if}
        {/if}
      </div>
    </div>
  </div>
  <div class="w-full mt-5 lg:w-4/5 lg:mt-auto">
    <div class={cssMenu}>
      <div
        class="flex flex-no-wrap items-start py-2 mx-auto my-1 overflow-x-auto justify-self-auto"
      >
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="CPU"
          href="/monitor"
          ><span class="text-xs font-bold"
            >{#if routerboards.cpuLoad}{routerboards.cpuLoad}%{/if}</span
          ></Aicon
        >
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="Free HDD"
          href="/monitor"
        >
          <span class="text-xs font-bold"
            >{#if routerboards.totalMemory}{prettyB(
                routerboards.freeHddSpace
              )}{/if}</span
          >
        </Aicon>
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="Total HDD"
          href="/monitor"
        >
          <span class="text-xs font-bold"
            >{#if routerboards.totalMemory}{prettyB(
                routerboards.totalHddSpace
              )}{/if}</span
          ></Aicon
        >
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="Free Memory"
          href="/monitor"
        >
          <span class="text-xs font-bold"
            >{#if routerboards.totalMemory}{prettyB(
                routerboards.freeMemory
              )}{/if}</span
          ></Aicon
        >
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="Total Memory"
          href="/monitor"
        >
          <span class="text-xs font-bold"
            >{#if routerboards.totalMemory}{prettyB(
                routerboards.totalMemory
              )}{/if}</span
          ></Aicon
        >
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="Uptime"
          href="/monitor"
        >
          <span class="text-xs font-bold"
            >{#if routerboards.totalMemory}{routerboards.uptime}{/if}</span
          ></Aicon
        >
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="Version"
          href="/monitor"
        >
          <span class="text-xs font-bold"
            >{#if routerboards.version}{routerboards.version}{/if}</span
          ></Aicon
        >
        <Aicon
          lg="w-2/12"
          md="w-1/6"
          xs="w-1/3"
          css="border"
          text="Version"
          href="/monitor"
        >
          <span class="text-xs font-bold"
            >{#if routerboards.version}{routerboards.version}{/if}</span
          ></Aicon
        >
      </div>
    </div>
  </div>
</div>
